import {http} from "@/api/HttpClient"
import {Character, CharacterSummary} from "@/characters/model/Character.ts";
import {Pageable, PageModel} from "@/api/Paging.ts";
import {SaveCharacterRequest} from "@/characters/admin/form/CharacterFormSchema.ts";

export async function searchCharacters(pageable: Pageable, params?: CharacterFilterParams, signal?: AbortSignal): Promise<PageModel<CharacterSummary>> {
    const res = await http.get<PageModel<CharacterSummary>>(`/characters`, {params: {...pageable, ...params}, signal});
    return res.data
}

export async function getCharacterById(id: string, signal?: AbortSignal): Promise<Character> {
    const res = await http.get<Character>(`/characters/${encodeURIComponent(id)}`, {signal});
    return res.data;
}

export async function saveCharacter(character: SaveCharacterRequest | Character): Promise<Character> {
    const response = await http.post<Character>(`/characters`, character);
    return response.data;
}

export async function deleteCharacter(id: string): Promise<void> {
    await http.delete<Character>(`/characters/${encodeURIComponent(id)}`);
}

export interface CharacterFilterParams {
    name?: string | null
    type?: string | null
    hostile?: boolean
    min?: number | null
    max?: number | null
}
